//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/list'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/tag_box'
import 'devextreme/ui/text_area'
import 'devextreme/ui/tooltip'
import 'devextreme/ui/tree_list'

//#endregion

import { TreeListController } from './tree-list.controller'
import { Api, LocalDictionaryFactory } from '../../api/api.module'

import { DATE_BOX_CONTROLS_SERVICE_NAME, DateBoxControlsService } from '../../../services/controls'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../services/data-type'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $STATE_SERVICE_NAME, $Q_SERVICE_NAME, $COMPILE_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import './tree-list.scss'
import * as TEMPLATE from './/tree-list.tpl.html'

//#endregion

export class TreeListDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        options: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $STATE_SERVICE_NAME,
        'logger',
        $Q_SERVICE_NAME,
        'localDictionary',
        'api',
        $COMPILE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_FORMAT_SERVICE_NAME,
        DATE_BOX_CONTROLS_SERVICE_NAME,
        (
            $scope,
            $timeout: ng.ITimeoutService,
            $state: StateService,
            logger,
            $q: ng.IQService,
            localDictionary: LocalDictionaryFactory,
            api: Api,
            $compile: ng.ICompileService,
            userSession: UserSessionService,
            dataFormatService: DataTypeFormatService,
            dateBoxControlsService: DateBoxControlsService
        ) => {
            return new TreeListController($scope, $timeout, $state, logger, $q, localDictionary, api, $compile, userSession, dataFormatService, dateBoxControlsService)
        }]

    template = TEMPLATE
    replace = true
    transclude = true
}